<template>
  <v-layout class="ma-0 pa-0" column>
    <vue-snotify></vue-snotify>
    <v-row>
      <!--courses-datatable-col -->
      <v-col cols="12" xs="12" :sm="colsNumber" :md="colsNumber">
        <v-card width="100%" class="mx-auto" flat>
          <!--courses-title -->
          <v-card-title
            class="headline font-weight-regular justify-space-between primary--text"
          >
            Courses
            <v-spacer></v-spacer>

            <v-btn
              class="mx-2"
              fab
              dark
              color="primary"
              @click="
                exportCSVFile(headersCSV, formatExportCourses, 'courses-table')
              "
            >
              <v-icon class="btn-icons">icons8-export-csv</v-icon></v-btn
            >
          </v-card-title>
          <!--/courses-title -->
          <v-divider class="secondary mx-4"></v-divider>

          <v-card-text class="text-left mt-4">
            <span class="grey--text text--darken-1">
              Use the search bar below to display the data you are looking for
              in the table below.
            </span>
            <v-text-field
              v-model="search"
              class="mb-2"
              append-icon="icons8-search-2"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <!--courses-datatable -->
            <v-data-table
              :headers="headers"
              :items="courses"
              :search="search"
              item-key="id"
              single-select
            >
              <template v-slot:[`item.codeRef`]="{ item }">
                <v-chip class="secondary">{{ item.codeRef }}</v-chip>
              </template>
              <template v-slot:[`item.authorised`]="{ item }">
                <v-icon v-if="item.authorised === true" class="secondary--text"
                  >icons8-checked-checkbox</v-icon
                >
                <v-icon v-else>icons8-unchecked-checkbox</v-icon>
              </template>
              <template v-slot:[`item.createdTimestamp`]="{ item }">
                <span class="text-capitalize">{{
                  formatDate(item.createdTimestamp)
                }}</span>
              </template>

              <template v-slot:[`item.expiryDate`]="{ item }">
                <span class="text-capitalize">{{
                  formatDate(item.expiryDate)
                }}</span>
              </template>

              <template v-slot:[`item.modifiedTimestamp`]="{ item }">
                <span class="text-capitalize">{{
                  formatDate(item.modifiedTimestamp)
                }}</span>
              </template>

              <template v-slot:[`item.estimatedDeliveryDate`]="{ item }">
                <span class="text-capitalize">{{
                  formatDate(item.estimatedDeliveryDate)
                }}</span>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-row align="end" justify="end" class="mr-1">
                  <v-icon
                    medium
                    class="mr-2 tableForeground--text font-weight-bold"
                    @click="editItem(item)"
                  >
                    icons8-edit
                  </v-icon>
                  <v-icon
                    medium
                    class=" tableForeground--text font-weight-bold"
                    @click="deleteItem(item)"
                  >
                    icons8-delete-bin
                  </v-icon>
                </v-row>
              </template>
            </v-data-table>
            <!--/courses-datatable -->
          </v-card-text>
        </v-card>
      </v-col>
      <!--/courses-datatable-col -->

      <!--edit-courses-col -->
      <v-col
        cols="12"
        xs="12"
        :sm="colsNumber"
        :md="colsNumber"
        v-if="editCourseFlag === true"
        class="grey lighten-3"
      >
        <v-card class="mx-auto grey lighten-3" flat>
          <v-card-title
            class="headline font-weight-regular justify-space-between py-7"
            >Edit Course</v-card-title
          >
          <v-divider class="secondary"></v-divider>
          <v-card-text class="text-left mx-2">
            <span class="grey--text text--darken-1">
              Use the fields below to modify the selected course.
            </span>
            <!--edit-courses-form -->
            <v-form ref="editForm" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="editCourseForm.numberOfParticipants"
                    outlined
                    class="white"
                    append-icon="icons8-user-group"
                    hide-details="auto"
                    label="Number of Participants"
                    type="number"
                    required
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="editCourseForm.ageGroupOfParticipants"
                    outlined
                    class="white"
                    multiple
                    :items="ageGroups"
                    append-icon="icons8-group-task-2"
                    hide-details="auto"
                    label="Participants Age Group"
                    required
                    :rules="requiredRules"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="editCourseForm.estimatedDeliveryDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editCourseForm.estimatedDeliveryDate"
                        label="Estimate Course Delivery Date"
                        append-icon="icons8-clock-2"
                        outlined
                        class="white"
                        readonly
                        v-on="on"
                        hide-details="auto"
                        required
                        :rules="requiredRules"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editCourseForm.estimatedDeliveryDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="
                          $refs.menu.save(editCourseForm.estimatedDeliveryDate)
                        "
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="editCourseForm.expiryDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editCourseForm.expiryDate"
                        label=" Course Expiry Date"
                        append-icon="icons8-clock-2"
                        outlined
                        class="white"
                        readonly
                        v-on="on"
                        hide-details="auto"
                        required
                        :rules="requiredRules"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editCourseForm.expiryDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu1 = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu1.save(editCourseForm.expiryDate)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-row class="mx-0">
                    <v-switch
                      inset
                      color="primary"
                      v-model="editCourseForm.authorised"
                      hide-details="auto"
                      class="pl-6"
                      style="margin-top: 10px !important"
                    ></v-switch>
                    <span
                      v-if="editCourseForm.authorised"
                      class="pt-4"
                      style=" font-size:16px !important"
                      >Authorised</span
                    >
                    <span v-else class="pt-4" style="font-size:16px !important"
                      >Not authorised</span
                    >
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
            <!--/edit-courses-form-->
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              align="end"
              class="ma-0 pa-0"
              justify="bottom"
            >
              <v-row class="pa-0">
                <v-col cols="12" class="ma-0 pa-0" align="end">
                  <v-btn
                    color="white"
                    class="mr-1 primary--text"
                    @click="editCourseFlag = !editCourseFlag"
                    ><v-icon size="13" left>icons8-delete</v-icon>Cancel</v-btn
                  >

                  <v-btn
                    color="primary"
                    class="mr-3 px-7 "
                    @click="saveEdited()"
                    ><v-icon small left> icons8-email-send</v-icon>Save</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
      <!--edit-courses-col -->
    </v-row>
  </v-layout>
</template>

<script>
import { Snotify, SnotifyPosition, SnotifyToast } from "vue-snotify";

export default {
  name: "Courses",

  data() {
    return {
      valid: true,
      search: "",
      dialog: false,
      headers: [
        {
          text: "Code",
          align: "start",
          filterable: false,
          value: "codeRef",
        },
        { text: "Authorised", value: "authorised" },
        { text: "Delivery date", value: "estimatedDeliveryDate" },
        { text: "Age group", value: "ageGroupOfParticipants" },
        { text: "No of participants", value: "numberOfParticipants" },
        { text: "Expires at", value: "expiryDate" },
        { text: "Topic", value: "topicName" },
        { text: "School", value: "schoolName" },
        { text: "Created by", value: "createdBy" },
        { text: "Created by email", value: "createdByEmail" },
        { text: "Created at", value: "createdTimestamp" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          hidden: false,
          align: "end",
        },
      ],

      headersCSV: {
        codeRef: "Code",
        authorised: "Authorised",
        estimatedDeliveryDate: "Delivery date",
        ageGroupOfParticipants: "Age Group",
        numberOfParticipants: "No Of Participants",
        expiryDate: "Expires at",
        topicName: "Topic",
        schoolName: "School Name",
        createdBy: "Created By",
        createdByEmail: "createdByEmail",
        createdTimestamp: "Created At",
        localAuthorityCountyName: "Local Authority County"
      },

      exportCourses: [],
      courses: [],
      changeWindowsFlag: false, // open invite user window
      returnedTopic: [],
      //edit user form
      editedIndex: -1,
      editedId: null,
      editCourseForm: {
        id: "",
        name: "",
        numberOfParticipants: "",
        ageGroupOfParticipants: [],
        estimatedDeliveryDate: "",
        userID: "",
        topicName: "",
        topicId: "",
        codeRef: "",
        authorised: true,
        createdBy: "",
        modifiedBy: "",
        createdByID: "",
        modifiedByID: "",
        createdByEmail: "",
        createdTimestamp: "",
        modifiedTimestamp: "",
        expiryDate: "",
        localAuthorityCountyName: ""
      },
      editCourseFlag: false, // open edit user window
      //validation rules
      nameRules: [(v) => !!v || "Full name is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      menu: false,
      menu1: false,
      ageGroups: [
        "Reception",
        "Year 1",
        "Year 2",
        "Year 3",
        "Year 4",
        "Year 5",
        "Year 6",
        "Year 7",
      ],
      requiredRules: [(v) => !!v || "This field is required"],
    };
  },
  computed: {
    colsNumber() {
      if (this.editCourseFlag) {
        return 6;
      } else {
        return 12;
      }
    },
    formatExportCourses() {
      this.exportCourses = [];
      for (var i = 0; i < this.courses.length; i++) {
        if (this.courses[i].authorised === true) {
          var authorised = "Yes";
        } else if (this.courses[i].authorised === "") {
          var authorised = "Unknown";
        } else {
          var authorised = "No";
        }

        if (this.courses[i].estimatedDeliveryDate != "") {
          var estimatedDeliveryDate = this.$moment(
            this.courses[i].estimatedDeliveryDate
          ).format("DD/MM/YYYY");
        } else {
          var estimatedDeliveryDate = "Unknown";
        }

        if (this.courses[i].ageGroupOfParticipants.length != 0) {
          var ageGroupOfParticipants = JSON.stringify(
            this.courses[i].ageGroupOfParticipants.join(", ")
          );
        } else {
          var ageGroupOfParticipants = "Unknown";
        }

        if (this.courses[i].codeRef != "") {
          var codeRef = this.courses[i].codeRef;
        } else {
          var codeRef = "Unknown";
        }

        if (this.courses[i].numberOfParticipants != "") {
          var numberOfParticipants = this.courses[i].numberOfParticipants;
        } else {
          var numberOfParticipants = "Unknown";
        }

        if (this.courses[i].expiryDate != "") {
          var expiryDate = this.$moment(this.courses[i].expiryDate).format(
            "DD/MM/YYYY"
          );
        } else {
          var expiryDate = "Unknown";
        }

        if (this.courses[i].topicName != "") {
          var topicName = this.courses[i].topicName;
        } else {
          var topicName = "Unknown";
        }

        if (this.courses[i].schoolName != "") {
          var schoolName = this.courses[i].schoolName;
        } else {
          var schoolName = "Unknown";
        }
         if (this.courses[i].createdByEmail != "") {
          var createdByEmail = this.courses[i].createdByEmail;
        } else {
          var createdByEmail = "No data";
        }
        if (this.courses[i].createdBy != "") {
          var createdBy = this.courses[i].createdBy;
        } else {
          var createdBy = "Unknown";
        }

        if (this.courses[i].createdTimestamp != "") {
          var createdTimestamp = this.$moment(
            this.courses[i].createdTimestamp
          ).format("DD/MM/YYYY");
        } else {
          var createdTimestamp = "Unknown";
        }

        if (this.courses[i].modifiedBy != "") {
          var modifiedBy = this.courses[i].modifiedBy;
        } else if (!this.courses[i].hasOwnProperty("modifiedBy")) {
          var modifiedBy = "Unknown";
        } else {
          var modifiedBy = "Unknown";
        }

        if (this.courses[i].modifiedTimestamp != "") {
          var modifiedTimestamp = this.$moment(
            this.courses[i].modifiedTimestamp
          ).format("DD/MM/YYYY");
        } else if (!this.courses[i].hasOwnProperty("modifiedTimestamp")) {
          var modifiedTimestamp = "Unknown";
        } else {
          var modifiedTimestamp = "Unknown";
        }

         if (this.courses[i].localAuthorityCountyName != "" && this.courses[i].localAuthorityCountyName != undefined) {
             var localAuthorityCountyName = this.courses[i].localAuthorityCountyName;
        } else {
          var localAuthorityCountyName = "Unknown";
        }


        //console.log(ageGroupOfParticipants);
        this.exportCourses.push({
          codeRef: codeRef,
          authorised: authorised,
          estimatedDeliveryDate: estimatedDeliveryDate,
          ageGroupOfParticipants: ageGroupOfParticipants,
          numberOfParticipants: numberOfParticipants,
          expiryDate: expiryDate,
          topicName: topicName,
          schoolName: schoolName,
          createdBy: createdBy,
          createdByEmail: createdByEmail,
          createdTimestamp: createdTimestamp,
          localAuthorityCountyName: localAuthorityCountyName
        });
      }
      return this.exportCourses;
    },
  },
  methods: {
    exportCSVFile(headers, items, fileTitle) {
      //console.log("headers:" + JSON.stringify(headers, null, 2));

      if (headers && items[0] != headers) {
        items.unshift(headers);
      }
      // console.log("items: " + JSON.stringify(items[1], null, 2));
      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);

      var csv = this.convertToCSV(jsonObject);
      // console.log(JSON.stringify(csv, null, 2))
      var exportedFilenmae = fileTitle + ".csv" || "export.csv";
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    // convert object to csv
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";
      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
    formatDate(date) {
      date = this.$moment(date).format("DD MMM YYYY");
      return date;
    },
    editItem(item) {
      //console.log(JSON.stringify(item));
      this.editedIndex = this.courses.indexOf(item);
      this.editCourseForm = Object.assign({}, item);
      this.editedId = item.id;
      this.editCourseFlag = true;
    },

    saveEdited() {
      var self = this;
      if (this.$refs.editForm.validate()) {
        self.editCourseForm.modifiedTimestamp = self.$moment().toISOString();
        self.editCourseForm.modifiedBy = self.$store.getters.currUser.fullName;
        self.editCourseForm.modifiedByID = self.$store.getters.currUser.id;
        //console.log(self.$store.getters.currUser.fullName);
        // console.log(self.editedId);

        self.$firebase.db
          .collection("courses")
          .doc(self.editedId)
          .set(self.editCourseForm)
          .then((docRef) => {
            self.$snotify.info("The course was edited.");
          })
          .catch((error) => {
            // console.log("Error adding document: ", error);
            self.$snotify.error(error);
          });

        Object.assign(self.courses[self.editedIndex], self.editCourseForm);
        var id = self.editCourseForm._id;
        delete self.editCourseForm._id;

        self.editCourseFlag = false;
      } else {
        //  console.log("not valid");
        self.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
    deleteItem(item) {
      const index = this.courses.indexOf(item);
      var id = item.id;
      //console.log("ID: " + id);

      this.$snotify.confirm(
        "Are you sure you want to delete this user?",
        "Delete user",
        {
          titleMaxLength: 250,
          maxOnScreen: 1,
          closeOnClick: false,
          pauseOnHover: true,
          position: SnotifyPosition.centerCenter,
          buttons: [
            //Yes
            {
              text: "Yes",
              action: (toast) => this.yesAction(id, index, toast),
              bold: false,
            },
            //No
            { text: "No", action: (toast) => this.$snotify.remove(toast.id) },
          ],
        }
      );
    },
    yesAction(id, index, toast) {
      var self = this;
      // delete course from firebase collection
      this.$firebase.db
        .collection("courses")
        .doc(id)
        .delete()
        .then(() => {
          self.$snotify.success("The course was deleted.");
        })
        .catch((error) => {
          self.$snotify.error(error);
        });
      this.courses.splice(index, 1); // remove user from datatable
      this.$snotify.remove(toast.id);
    },
    readTopicById(id) {
      var self = this;
      this.$firebase.db
        .collection("topics")
        .where("id", "==", id)
        .onSnapshot((querySnapshot) => {
          var Data = [];
          querySnapshot.forEach((doc) => {
            Data = doc.data();
            Data.id = doc.id;
            self.returnedTopic.push(Data);
          });
        });
    },
    returnTopicName(id) {
      this.readTopicById(id);
      if (this.returnedTopic[0] === undefined) {
        return "";
      } else {
        return this.returnedTopic[0].name;
      }
    },
  },
  created() {
    var self = this;
    this.$firebase.db.collection("courses").onSnapshot((querySnapshot) => {
      self.courses = [];
      var Data = [];
      querySnapshot.forEach((doc) => {
        Data = doc.data();
        Data.id = doc.id;
        self.courses.push(Data);
      });
    });
  },
};
</script>
